<template>
  <h6 class="mb-1">{{ order }}) {{ freeField1 }}</h6>
  <p>{{ freeField2 }}</p>
  <div class="d-flex">
    <button
      v-for="option in options"
      :key="option.value"
      type="button"
      class="btn btn-likert"
      :class="{ selected: Number(value) === option.value }"
      :title="option.label"
      @click="setValue(option.value)"
    >
      <div class="d-flex flex-column align-items-center">
        <img :src="option.icon" :alt="option.label" />
        <p class="mb-0">{{ option.label }}</p>
      </div>
    </button>
  </div>
</template>

<script>
import scale1 from '@/assets/img/likert/1.svg'
import scale2 from '@/assets/img/likert/2.svg'
import scale3 from '@/assets/img/likert/3.svg'
import scale4 from '@/assets/img/likert/4.svg'
import scale5 from '@/assets/img/likert/5.svg'

export default {
  name: 'LikertIconsScale',

  props: {
    order: {
      type: [String, Number],
      default: '1',
    },
    freeField1: {
      type: String,
      default: 'Qual é sua avaliação',
    },
    freeField2: {
      type: String,
      default: '',
    },
    freeField3: {
      type: String,
      default: '',
    },
    userDistribution: {
      type: Object,
      default: null,
    },
  },

  emits: ['setValue'],

  data() {
    return {
      options: [
        { value: 1, icon: scale1, label: 'Péssimo' },
        { value: 2, icon: scale2, label: 'Ruim' },
        { value: 3, icon: scale3, label: 'Regular' },
        { value: 4, icon: scale4, label: 'Bom' },
        { value: 5, icon: scale5, label: 'Excelente' },
      ],
      value: '',
    }
  },

  methods: {
    setValue(value) {
      if (this.userDistribution) {
        const newUserDistribution = { ...this.userDistribution }
        newUserDistribution.value = value
        this.$emit('setValue', newUserDistribution)
      }
      this.value = value
    },
  },

  mounted() {
    if (this.userDistribution) {
      this.value = this.userDistribution.value
    }
  },
}
</script>

<style scoped>
.btn-likert {
  background-color: transparent;
  border: none;
  cursor: pointer;
  transition: all 0.3s ease;
  margin: 0 10px;
  width: 75px;
}

.btn-likert img {
  width: 50px;
  height: 50px;
  margin-bottom: 5px;
  transition: all 0.3s ease;
}

.btn-likert p {
  font-size: 12px;
  font-weight: 400;
  color: #000;
  transition: all 0.3s ease;
}

.btn-likert:hover {
  transform: scale(1.02);
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.2);
}

.btn-likert:hover p {
  color: #007bff;
}

.btn-likert.selected {
  transform: scale(1.05);
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.3);
}

.btn-likert.selected img {
  border-radius: 50%;
  transform: scale(1.1);
}

.btn-likert.selected p {
  font-weight: 600;
  color: #007bff;
}

@media (max-width: 600px) {
  .btn-likert img {
    width: 30px;
    height: 30px;
  }

  .btn-likert p {
    font-size: 8px;
  }
}
</style>
